module.exports = "https://web-assets-production.autolist.com/_next/static/images/section-bg-wheel-light-4666ee998056597bebd5d03c83ea73cf.jpg";